import { GameModeCard } from "@Components/game/game-mode";
import MatchPlaySettingSlider from "@Components/game/match-play/match-play-setting-slider";
import { useMatchPlayContext } from "@Context/game/match-play/match-play-context";
import {
  getDifficultyLabelKey,
  getMatchPlayDifficultyValue,
  getMatchPlaySpeedValue,
  getSpeedLabelKey,
  matchPlayDefaults,
  matchPlaySettingValues,
} from "@Helpers/match-play";
import useI18n from "@i18n";
import { Stack } from "@mui/material";

const MatchPlaySettings = () => {
  const { i18n } = useI18n();
  const { difficulty, gameSpeed, gameDuration, handleDifficultyChange, handleGameSpeedChange, handleGameDurationChange, isWaitingForGameplay } =
    useMatchPlayContext();
  return (
    <Stack flexDirection="column" flex={0.4} gap={2}>
      <GameModeCard>
        <MatchPlaySettingSlider
          disabled={isWaitingForGameplay}
          label={i18n("match-play.difficulty")}
          max={matchPlaySettingValues.difficulty.hard}
          min={matchPlaySettingValues.difficulty.easy}
          marks={Object.values(matchPlaySettingValues.difficulty).map(value => ({ value }))}
          onChange={handleDifficultyChange}
          step={null}
          value={getMatchPlayDifficultyValue(difficulty)}
          valueLabel={i18n(getDifficultyLabelKey(getMatchPlayDifficultyValue(difficulty)))}
        />
      </GameModeCard>

      <GameModeCard>
        <MatchPlaySettingSlider
          disabled={isWaitingForGameplay}
          label={i18n("match-play.game-speed")}
          max={matchPlaySettingValues.speed.fast}
          min={matchPlaySettingValues.speed.slow}
          marks={Object.values(matchPlaySettingValues.speed).map(value => ({ value }))}
          onChange={handleGameSpeedChange}
          step={null}
          value={getMatchPlaySpeedValue(gameSpeed)}
          valueLabel={i18n(getSpeedLabelKey(getMatchPlaySpeedValue(gameSpeed)))}
        />
      </GameModeCard>

      <GameModeCard>
        <MatchPlaySettingSlider
          disabled={isWaitingForGameplay}
          label={i18n("match-play.game-duration")}
          max={matchPlayDefaults.duration.max}
          min={matchPlayDefaults.duration.min}
          marks={Array.from({ length: matchPlayDefaults.duration.max - matchPlayDefaults.duration.min + 1 }, (_, index) => ({
            value: matchPlayDefaults.duration.min + index,
          }))}
          onChange={handleGameDurationChange}
          value={gameDuration}
          valueLabel={`${gameDuration} ${i18n("minute")}`}
        />
      </GameModeCard>
    </Stack>
  );
};

export default MatchPlaySettings;
